import { getOuterUrl, urijs } from '@wix/communities-blog-client-common';

interface Topology {
  baseUrl?: string;
  postPagePath?: string;
  postPageSectionUrl?: string;
}

const getPostUrl = (topology: Topology, paths: string[]) =>
  urijs
    .joinPaths(
      urijs(topology.baseUrl as string).pathname(),
      topology.postPagePath as string,
      ...paths,
    )
    .absoluteTo(topology.baseUrl as string)
    .toString();

export const getCreatePostUrl = (topology: Topology) =>
  getOuterUrl('/create-post', topology.postPageSectionUrl as string);
export const getEditPostUrl = (topology: Topology, postId: string) =>
  getOuterUrl(`/${postId}/edit`, topology.postPageSectionUrl as string);

export default getPostUrl;
